export enum FmeaStatusEnum {
  Inactive = 0,
  Active = 1,
}

export default FmeaStatusEnum;
